import VueRouter, { Route } from 'vue-router';
import { bridge } from './bridge';

const HistoryStack: Route[][] = [];

function compareRoute(a: Route, b: Route) {
  return a.fullPath === b.fullPath;
}

function inHistoryStep(to: Route) {
  const toList = HistoryStack.map((history) => history[1]).reverse();
  for (let i = 0; i < toList.length; i++) {
    if (compareRoute(toList[i], to)) {
      return i;
    }
  }
  return 0;
}

export function initTransPage(router: VueRouter) {
  router.beforeEach((to: Route, from: Route, next: () => void) => {
    if (from.matched.length > 0) {
      const historyStep = inHistoryStep(to);
      if (historyStep > 0) {
        bridge.transPageGo(-historyStep);
      } else {
        bridge.transPageGo(1);
      }
    }
    next();
  });

  router.beforeResolve((to: Route, from: Route, next: () => void) => {
    if (from.matched.length > 0) {
      const historyStep = inHistoryStep(to);
      if (historyStep > 0) {
        // 后退
        HistoryStack.splice(HistoryStack.length - historyStep, historyStep);
        bridge.readyForTransPage(-historyStep);
      } else {
        // 前进
        const lastHistory = HistoryStack[HistoryStack.length - 1];
        HistoryStack.push([lastHistory[1], to]);
        bridge.readyForTransPage(1);
      }
    } else {
      // 应用的入口页面
      HistoryStack.push([to, to]);
    }
    next();
  });
}
